import React from "react";
import "./ContactSection.css";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ContactSection() {
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}api/v1/contactus/`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) throw new Error("Something went wrong");

      toast.success("Message sent successfully!", {
        position: "bottom-right",
      });
      e.target.reset();
    } catch (error) {
      console.error(error);
      toast.error("Failed to send message. Please try again.", {
        position: "bottom-right",
      });
    }
  };

  return (
    <>
      <section
        className="contact-section"
        aria-label={t(
          "home.contact.ariaLabel",
          "Contact and transform your career"
        )}
      >
        <div className="contact-inner">
          <div className="contact-left">
            <h2 className="contact-headline">
              {t("home.contact.headline.part1")}
              <br />
              <span className="accent">
                {t("home.contact.headline.accent")}
              </span>
              {t("home.contact.headline.part2")}
              <br />
              {t("home.contact.headline.part3")}
            </h2>

            <p className="contact-desc">
              {t("home.contact.description")}
            </p>

            <div className="social-row">
              <a
                className="social-btn"
                href="https://www.linkedin.com/company/nxnearby/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Open NXNearby on LinkedIn"
              >
                <img
                  src="/Image/Hero/linkedin.png"
                  alt=""
                  className="social-icon"
                />
              </a>
            </div>
          </div>

          <aside
            className="contact-card"
            aria-labelledby="contact-heading"
            role="form"
          >
            <div className="card-inner">
              <h3 id="contact-heading" className="card-title">
                {t("home.contact.card.title")}
              </h3>
              <p className="card-sub">
                {t("home.contact.card.sub")}
              </p>

              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="input-wrapper">
                  <img
                    src="/Image/Hero/Name.svg"
                    alt=""
                    className="input-icon"
                  />
                  <input
                    id="name"
                    name="name"
                    className="input"
                    placeholder={t("home.contact.form.namePlaceholder")}
                    aria-label={t(
                      "home.contact.form.nameAria",
                      "Your name"
                    )}
                  />
                </div>

                <div className="row two-cols">
                  <div className="input-wrapper">
                    <img
                      src="/Image/Hero/Email.svg"
                      style={{ left: 32 }}
                      alt=""
                      className="input-icon"
                    />
                    <input
                      id="email"
                      name="email"
                      className="input"
                      placeholder={t(
                        "home.contact.form.emailPlaceholder"
                      )}
                      aria-label={t(
                        "home.contact.form.emailAria",
                        "Email address"
                      )}
                    />
                  </div>

                  <div className="input-wrapper">
                    <img
                      src="/Image/Hero/Phone number.svg"
                      style={{ left: 32 }}
                      alt=""
                      className="input-icon"
                    />
                    <input
                      id="phone_number"
                      name="phone_number"
                      className="input"
                      placeholder={t(
                        "home.contact.form.phonePlaceholder"
                      )}
                      aria-label={t(
                        "home.contact.form.phoneAria",
                        "Phone number (optional)"
                      )}
                    />
                  </div>
                </div>

                <input
                  id="subject"
                  name="subject"
                  className="input"
                  placeholder={t(
                    "home.contact.form.subjectPlaceholder"
                  )}
                  aria-label={t(
                    "home.contact.form.subjectAria",
                    "Subject"
                  )}
                />

                <textarea
                  id="message"
                  name="message"
                  className="textarea"
                  rows="6"
                  placeholder={t(
                    "home.contact.form.messagePlaceholder"
                  )}
                  aria-label={t(
                    "home.contact.form.messageAria",
                    "Your message"
                  )}
                />

                <button
                  type="submit"
                  className="btn-gradient"
                  aria-label={t(
                    "home.contact.form.submitAria",
                    "Send Message"
                  )}
                >
                  <span className="btn-icon" aria-hidden="true">
                    <img
                      src="/Image/Hero/Send message.svg"
                      width="26"
                      height="24"
                      alt=""
                      style={{ paddingBottom: 3 }}
                    />
                  </span>
                  <span>{t("home.contact.form.submitText")}</span>
                </button>

                <div className="privacy-note">
                  {t("home.contact.privacyNote")}
                </div>
              </form>
            </div>
          </aside>
        </div>
      </section>

      <ToastContainer />
    </>
  );
}
